import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {
  PersonListModel,
  FilterBookingModel,
  CheckinListModel,
  CheckoutListModel,
  GuestListModel,
  GuestFileModel,
  GuestFileDetailModel,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

// -------------------- LISTA PERSONA

export function getOpaListGuestService(dto: FilterBookingModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<PersonListModel[]>>(
    `${BASEURL}/OPA/getGuestsByLoadType/${pageNumber}`,
    dto,
  )
}

export function getOpaGuestService(dto: GuestListModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<GuestListModel[]>>(
    `${BASEURL}/OPA/getAllGuest/${pageNumber}`,
    dto,
  )
}

// -------------------- LISTA CHECKIN

export function getOpaListGuestCheckinService(dto: FilterBookingModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<CheckinListModel[]>>(
    `${BASEURL}/OPA/getGuestsCheckinPending/${pageNumber}`,
    dto,
  )
}
export function getOpaGuestCheckinService(dto: GuestListModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<GuestListModel[]>>(
    `${BASEURL}/OPA/getAllGuestCheckin/${pageNumber}`,
    dto,
  )
}

// -------------------- LISTA CHECKOUT

export function getOpaListGuestCheckoutService(dto: FilterBookingModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<CheckoutListModel[]>>(
    `${BASEURL}/OPA/getGuestsPendingCheckout/${pageNumber}`,
    dto,
  )
}

export function getOpaGuestCheckoutService(dto: GuestListModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<GuestListModel[]>>(
    `${BASEURL}/OPA/getAllGuestCheckout/${pageNumber}`,
    dto,
  )
}

// ----------------------- PERSONA NO CARGADAS -ARCHIVOS

export function getOpaGuestFileService(dto: GuestFileModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<GuestFileModel[]>>(
    `${BASEURL}/OPA/getAllIntegrationLoadTray/${pageNumber}?size=10`,
    dto,
  )
}

export function getOpaGuestFileDetailService(dto: GuestFileDetailModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<GuestFileDetailModel[]>>(
    `${BASEURL}/OPA/getAllIntegrationLoadTrayDetail/${pageNumber}`,
    dto,
  )
}

// -------------------- EXPORT
export function getListPersonExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/OPA/getGuestsByLoadTypeExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getListPendingCheckinExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/OPA/getGuestsCheckinPendingExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}
export function getListPendingCheckoutExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/OPA/getGuestsPendingCheckoutExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}
